<template>
    <div class="card">
        <div class="card-header">
            <h5>AddWord Revenue Report</h5>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="col-md-6">
                                <label for="affiliate" class="form-label"> Affiliate </label>
                                <v-select
                                    placeholder="Select Affiliates"
                                    :options="affiliates"
                                    label="name"
                                    class="m-0"
                                    id="affiliate"
                                    index="id"
                                    v-model="revenueReport.selectedAffiliate"
                                    multiple
                                />
                                <!-- <small class="text-danger" v-if="reportFilters.affiliate.error">{{ reportFilters.affiliate.error }}</small> -->
                            
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <label for="salesreport.tourname" class="form-label">Tour Name</label> 
                            <v-select
                                placeholder="Tours"
                                :options="tours"
                                label="name"
                                class="m-0"
                                id="tour"
                                index="id"
                                v-model="revenueReport.tour"
                                multiple
                            />
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-12">
                        <h6>Add-Word Placement Date Range</h6>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-10">
                            <div class="row mt-2">
                                <div class="col-md-6">
                                <dateTimePicker
                                    no-label
                                    label="From Date"
                                    id="departureDateStart"
                                    format="YYYY-MM-DD"
                                    formatted="YYYY-MM-DD"
                                    v-model="revenueReport.placementStartDate"
                                    button-color="#ec391e"
                                    :only-date="true"
                                    color="#ec391e"
                                    style="border: 1px solid #DFE5F9"
                                />
                                <!-- <small class="text-danger" v-if="errors.departure_start">{{ errors.departure_start }}</small> -->
                                </div>
                                <div class="col-md-6">
                                <dateTimePicker
                                    no-label
                                    label="To Date"
                                    id="departureDateEnd"
                                    format="YYYY-MM-DD"
                                    formatted="YYYY-MM-DD"
                                    v-model="revenueReport.placementEndDate"
                                    button-color="#ec391e"
                                    :only-date="true"
                                    color="#ec391e"
                                    style="border: 1px solid #DFE5F9"
                                    :min-date="revenueReport.placementStartDate"
                                />
                                <!-- <small class="text-danger" v-if="errors.departuare_end">{{ errors.departuare_end }}</small> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <label for="checkbox" class="form-label">Tour Based</label>
                            <br>
                            <label class="switch">
                                <input v-model="revenueReport.tourBased" id="checkbox" type="checkbox"/>
                                <span class="switch__slider"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer align-items-right">
            <button type="submit" class="button" @click="getRevenueReport">
                Generate report
            </button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'AddWordRevenueReportFields',
    props:{
        tours:Array
    },   
    data() {
        return {
            revenueReport: {
                placementStartDate:null,
                placementEndDate: null,
                tour: [],
                selectedAffiliate:[],
                tourBased: false
            },
            affiliates:[]
        }
    },
    mounted(){
      this.getAffiliates()
    },
    methods: {
        getAffiliates() {
            axios.get(this.$api + 'affiliates?type=active',
            {
            headers:{
                'Accept': 'application/json',
                'Authorization': localStorage.getItem('token')
            }
            })
            .then((response) => {
                if (response.data.success) {
                    this.affiliates = response.data.data
                }
            });
        },
        validateFields()
        {
            let This = this
            return new Promise((resolve, reject) =>
            {

                let errorCount = 0;

                // // Departure Dates validation
                // if(This.salesreport.departureDateStart && !This.salesreport.departureDateEnd) {
                //     This.errors.departuare_end = "Please select a valid departure to date"
                //     errorCount +=1
                // }else if(This.salesreport.departureDateEnd && !This.salesreport.departureDateStart){
                //     This.errors.departure_start = "Please select a valid departure from date"
                //     errorCount +=1
                // }else{
                //     This.errors.departuare_end = null
                //     This.errors.departure_start = null
                // }

                // // Booking Dates validation 
                // if(This.salesreport.bookingDateStart && !This.salesreport.bookingDateEnd) {
                //     This.errors.booking_end = "Please select a valid booking to date"
                //     errorCount +=1
                // }else if(This.salesreport.bookingDateEnd && !This.salesreport.bookingDateStart){
                //     This.errors.booking_start = "Please select a valid booking from date"
                //     errorCount +=1
                // }else{
                //     This.errors.booking_end = null
                //     This.errors.booking_start = null
                // }
                
                // // Check for Departure date and Booking date
                // if ( !This.salesreport.departureDateStart && !This.salesreport.bookingDateStart) 
                // {
                //     This.errors.departure_start = "Please select departure date or booking date"
                //     This.errors.booking_start = "Please select booking date or departure date"

                //     errorCount +=1
                // }else{
                //     This.errors.departure_start = null
                //     This.errors.booking_start = null
                // }


                resolve(true)
                // if(errorCount == 0 ){
                // }else{
                //     reject(true)
                // }

            })
        },
        getRevenueReport()
        {
            this.validateFields()
            .then((response) => {
                if (response) {
                    this.$store.dispatch("setLoadStatus");
                    
                    fetch(this.$api + 'reports/addword-revenue-report', {
                        method: 'POST',
                        body: JSON.stringify({...this.revenueReport}),
                        headers:{
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'Authorization': localStorage.getItem('token')
                        }
                    })
                    .then((res) => {
                        if(res.status === 200) {
                            this.$store.dispatch('setLoadStatus')
                            res.blob().then(response => {
                                const _url = window.URL.createObjectURL(response)
                                const link = document.createElement('a')
                                link.href = _url
                                link.setAttribute('download', 'advertisement_revenu_report.xlsx')
                                document.body.appendChild(link)
                                link.click();
                            })
                        }
                        else {
                            this.$store.dispatch('setLoadStatus')
                            Promise.race([res.json()])
                            .then(response => {
                                if(response.message) {
                                this.$notify({
                                    type: 'error',
                                    title: response.message
                                });
                                } else {
                                this.$notify({
                                    type: 'error',
                                    title: response.error
                                });
                                }
                            })
                        }
                    })
                }
            })
            .catch(error => console.log(error))

        },
    }     
}
</script>

<style lang="scss" scoped>

</style>